import { render, staticRenderFns } from "./SkeletonMobile.vue?vue&type=template&id=f4bcc09e&scoped=true"
import script from "./SkeletonMobile.vue?vue&type=script&lang=js"
export * from "./SkeletonMobile.vue?vue&type=script&lang=js"
import style0 from "./SkeletonMobile.vue?vue&type=style&index=0&id=f4bcc09e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bcc09e",
  null
  
)

export default component.exports